import { onDocumentReady } from "../../common/on-document-ready";
import { GeneralComposer } from "./general-composer";
export class SessionFiltersFinder {
    constructor(response) {
        this.composers = [new GeneralComposer()];
        response.json().then((data) => {
            onDocumentReady(() => {
                this.showFilters(data.filters);
            });
        });
    }
    showFilters(filters) {
        if (Array.isArray(filters)) {
            for (const filterGroup of filters) {
                for (const composer of this.composers) {
                    if (composer.isForFilterType(filterGroup.filterType)) {
                        composer.showFilters(filterGroup);
                    }
                }
            }
        }
        for (const composer of this.composers) {
            composer.cleanUp();
        }
    }
    static init() {
        if (window["sessionFiltersUrl"]) {
            const response = fetch(window["sessionFiltersUrl"]);
            response.then((response) => {
                new SessionFiltersFinder(response);
            });
        }
    }
}
